import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { exportOrdersExcelAction } from "../redux/actions/orderActions";
import Loader from "./loader/loader";
import { toast } from "react-toastify";
import { clearErrors } from "../redux/actions/userActions";
import api from "../api";

const ExportOrders = () => {
    const dispatch = useDispatch();
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [status, setStatus] = useState("");
    const [product_id, setProduct_id] = useState("");
    const [userType, setUserType] = useState("");
    const [userId, setUserId] = useState("");
    const [pms, setPms] = useState([]);
    const [pmms, setPmms] = useState([]);

    const { user } = useSelector((state) => state.verifyEmailStore);
    const { loading, error } = useSelector((state) => state.exportOrders);



    const handleExport = () => {
        dispatch(exportOrdersExcelAction({ dateFrom, dateTo, status, product_id, userType, userId }));
    };

    useEffect(() => {
        if (user?.role === "PMM") {
            setUserType("PM");
        }
    }, [user]);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const pmmRes = await api.get('/api/v1/view-all-pmms?role=PMM&perPage=1000');
                setPmms(pmmRes.data.users || pmmRes.data.PMMs || []);
                
                const pmRes = await api.get('/api/v1/view-all-pmms?role=PM&perPage=1000');
                setPms(pmRes.data.users || pmRes.data.PMMs || []);
            } catch (error) {
                console.error("Error fetching users for reports:", error);
            }
        };
        
        if (user?.role === "SUPER_ADMIN" || user?.role === "ADMIN") {
            fetchUsers();
        }
    }, [user]);



    useEffect(() => {
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }
    }, [error, dispatch]);

    return (
        <Fragment>
            {loading && <Loader />}

            {/* Breadcrumb Header */}
            <section className='p-3 md:p-6'>
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center bg-white p-4 md:p-5 rounded-2xl shadow-sm border border-gray-100 gap-2 sm:gap-4">
                    <div className="flex items-center gap-3">
                        <div className="w-1 h-6 bg-indigo-600 rounded-full"></div>
                        <h2 className='text-base md:text-xl font-extrabold text-gray-800 uppercase tracking-wider'>Report Center</h2>
                    </div>
                    <div className="flex items-center gap-2 text-xs md:text-sm font-semibold text-gray-500 ml-4 sm:ml-0">
                        <span>Analytics</span>
                        <i className="fa-solid fa-chevron-right text-gray-300 text-[8px]"></i>
                        <span className='text-indigo-600'>Create Reports</span>
                    </div>
                </div>
            </section>


            <section className="px-3 md:px-6 pb-20">
                <div className="bg-white rounded-3xl shadow-xl shadow-gray-200/40 border border-gray-100 overflow-hidden">
                    {/* Header Section */}
                    <div className="p-5 md:p-8 bg-gradient-to-br from-gray-50/50 to-white border-b border-gray-50 flex items-center gap-4">
                        <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl md:rounded-2xl bg-indigo-600 text-white flex items-center justify-center shadow-lg shadow-indigo-100 shrink-0">
                            <i className="fa-solid fa-file-export text-lg md:text-xl"></i>
                        </div>
                        <div>
                            <h3 className="font-bold text-gray-800 text-base md:text-xl">Export Orders Report</h3>
                            <p className="text-gray-500 text-xs md:text-sm line-clamp-1">Filter and generate detailed Excel reports</p>
                        </div>
                    </div>

                    <div className="p-4 md:p-8 space-y-10">

                        {/* Filters Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

                            {/* Group 1: Date Range */}
                            <div className="space-y-5">
                                <div className="flex items-center gap-3">
                                    <div className="w-8 h-8 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center shrink-0">
                                        <i className="fa-regular fa-calendar-days text-sm"></i>
                                    </div>
                                    <span className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em]">Date Range</span>
                                    <div className="h-[1px] flex-1 bg-gray-50"></div>
                                </div>
                                <div className="space-y-4">
                                    <div className="flex flex-col gap-1.5">
                                        <label className="text-[11px] font-bold text-gray-500 ml-1 uppercase">Date From</label>
                                        <input
                                            type="date"
                                            value={dateFrom}
                                            onChange={(e) => setDateFrom(e.target.value)}
                                            className="w-full bg-gray-50/50 px-4 py-3 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50/50 transition-all text-sm font-semibold text-gray-700"
                                        />
                                    </div>
                                    <div className="flex flex-col gap-1.5">
                                        <label className="text-[11px] font-bold text-gray-500 ml-1 uppercase">Date To</label>
                                        <input
                                            type="date"
                                            value={dateTo}
                                            onChange={(e) => setDateTo(e.target.value)}
                                            className="w-full bg-gray-50/50 px-4 py-3 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50/50 transition-all text-sm font-semibold text-gray-700"
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Group 2: Order Details */}
                            <div className="space-y-5">
                                <div className="flex items-center gap-3">
                                    <div className="w-8 h-8 rounded-lg bg-purple-50 text-purple-600 flex items-center justify-center shrink-0">
                                        <i className="fa-solid fa-layer-group text-sm"></i>
                                    </div>
                                    <span className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em]">Order Details</span>
                                    <div className="h-[1px] flex-1 bg-gray-50"></div>
                                </div>
                                <div className="space-y-4">
                                    <div className="flex flex-col gap-1.5">
                                        <label className="text-[11px] font-bold text-gray-500 ml-1 uppercase">Order Status</label>
                                        <div className="relative">
                                            <select
                                                value={status}
                                                onChange={(e) => setStatus(e.target.value)}
                                                className="w-full bg-gray-50/50 px-4 py-3 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50/50 transition-all text-sm font-semibold text-gray-700 appearance-none cursor-pointer"
                                            >
                                                <option value="">All Statuses</option>
                                                <option value="ORDERED">Ordered</option>
                                                <option value="REVIEWED">Reviewed</option>
                                                <option value="ON_HOLD">On Hold</option>
                                                <option value="DELIVERED">Delivered</option>
                                                <option value="REFUNDED">Refunded</option>
                                                <option value="COMMISSIONED">Commissioned</option>
                                                <option value="COMPLETED">Completed</option>
                                                <option value="CANCELLED">Cancelled</option>
                                                <option value="REVIEW_DELETED">Review Deleted</option>
                                            </select>
                                            <i className="fa-solid fa-chevron-down absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none text-[10px]"></i>
                                        </div>
                                    </div>
                                    <div className="flex flex-col gap-1.5">
                                        <label className="text-[11px] font-bold text-gray-500 ml-1 uppercase">Product ID</label>
                                        <div className="relative group">
                                            <i className="fa-solid fa-barcode absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-500 transition-colors"></i>
                                            <input
                                                type="text"
                                                value={product_id}
                                                onChange={(e) => setProduct_id(e.target.value)}
                                                className="w-full bg-gray-50/50 pl-11 pr-4 py-3 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50/50 transition-all text-sm font-semibold text-gray-700"
                                                placeholder="Ex: 12345"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Group 3: User Identification */}
                            <div className="space-y-5">
                                <div className="flex items-center gap-3">
                                    <div className="w-8 h-8 rounded-lg bg-orange-50 text-orange-600 flex items-center justify-center shrink-0">
                                        <i className="fa-solid fa-users-viewfinder text-sm"></i>
                                    </div>
                                    <span className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em]">User Filters</span>
                                    <div className="h-[1px] flex-1 bg-gray-50"></div>
                                </div>
                                <div className="space-y-4">
                                    {user?.role !== "PMM" && user?.role !== "PM" && (
                                        <div className="flex flex-col gap-1.5">
                                            <label className="text-[11px] font-bold text-gray-500 ml-1 uppercase">User Type</label>
                                            <div className="relative">
                                                <select
                                                    value={userType}
                                                    onChange={(e) => setUserType(e.target.value)}
                                                    className="w-full bg-gray-50/50 px-4 py-3 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50/50 transition-all text-sm font-semibold text-gray-700 appearance-none cursor-pointer"
                                                >
                                                    <option value="">Select User type</option>
                                                    <option value="PMM">PMM (Seller)</option>
                                                    <option value="PM">PM (Buyer)</option>
                                                </select>
                                                <i className="fa-solid fa-chevron-down absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none text-[10px]"></i>
                                            </div>
                                        </div>
                                    )}
                                    {user?.role !== "PM" && (
                                        <div className="flex flex-col gap-1.5">
                                            <label className="text-[11px] font-bold text-gray-500 ml-1 uppercase">Target User ID</label>
                                            <div className="relative">
                                                <i className="fa-regular fa-id-badge absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"></i>
                                                <select
                                                    value={userId}
                                                    onChange={(e) => setUserId(e.target.value)}
                                                    className="w-full bg-gray-50/50 pl-11 pr-4 py-3 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50/50 transition-all text-sm font-semibold text-gray-700 appearance-none cursor-pointer"
                                                >
                                                    <option value="">{userType ? `All ${userType}s` : "Select type first"}</option>
                                                    {userType === "PM" && pms.map(u => (
                                                        <option key={u.id} value={u.id}>{u.name} (ID: {u.id})</option>
                                                    ))}
                                                    {userType === "PMM" && pmms.map(u => (
                                                        <option key={u.id} value={u.pmm_id}>{u.name} (PMM ID: {u.pmm_id})</option>
                                                    ))}
                                                </select>
                                                <i className="fa-solid fa-chevron-down absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none text-[10px]"></i>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Action Footer */}
                        <div className="pt-8 border-t border-gray-50 flex flex-col sm:flex-row items-center justify-between gap-6">
                            <div className="flex items-center gap-3 text-gray-400 text-[10px] font-bold bg-gray-50 px-4 py-2 rounded-xl">
                                <i className="fa-solid fa-circle-info text-indigo-400"></i>
                                <span className="uppercase tracking-wider">Reports Format: <b>.xlsx</b></span>
                            </div>
                            <button
                                onClick={handleExport}
                                className="w-full sm:w-auto bg-indigo-600 hover:bg-indigo-700 text-white rounded-2xl py-4 px-10 font-bold text-sm md:text-base flex items-center justify-center gap-3 shadow-xl shadow-indigo-100 hover:shadow-indigo-200 transition-all hover:-translate-y-1 active:translate-y-0"
                            >
                                <i className="fa-solid fa-file-excel text-lg"></i>
                                Export Excel Report
                            </button>
                        </div>
                    </div>
                </div>
            </section>

        </Fragment>
    );
};

export default ExportOrders;